import React from "react";
import PropTypes from "prop-types";
import { useMap } from "react-leaflet";
import { LatLngBoundsExpression } from "leaflet";
import { LOCAL_STORAGE_DEFAULT_MAP_BOUNDS } from "../../types/constants";

const ZoomControlWithReset = (props: {
  zoomInTitle: any;
  zoomResetTitle: any;
  zoomOutTitle: any;
  localStorageMapBound: string;
  bounds: LatLngBoundsExpression;
}) => {
  const { zoomInTitle, zoomResetTitle, zoomOutTitle, localStorageMapBound, bounds } = props;

  const map = useMap();

  return (
    <div className="leaflet-control leaflet-control-zoom leaflet-bar">
      <a
        className="leaflet-control-zoom-in"
        href="#"
        title={zoomInTitle}
        role="button"
        aria-label="Zoom in"
        onClick={(e) => {
          map.zoomIn();
          e.preventDefault();
        }}
      >
        +
      </a>
      <a
        className="leaflet-control-zoom-out"
        href="#"
        title={zoomOutTitle}
        role="button"
        aria-label="Zoom out"
        onClick={(e) => {
          map.zoomOut();
          e.preventDefault();
        }}
      >
        -
      </a>
      <a
        className="leaflet-control-zoom-out"
        href="#"
        title={zoomResetTitle}
        role="button"
        aria-label="Reset zoom"
        onClick={(e) => {
          map.fitBounds(bounds);
          if(localStorageMapBound){
            localStorage.removeItem(localStorageMapBound);
          }
          localStorage.removeItem(LOCAL_STORAGE_DEFAULT_MAP_BOUNDS);
          e.preventDefault();
        }}
      >
        &#x21ba;
      </a>
    </div>
  );
};

ZoomControlWithReset.propTypes = {
  zoomInTitle: PropTypes.string,
  zoomOutTitle: PropTypes.string,
  zoomResetTitle: PropTypes.string,
  bounds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
};

ZoomControlWithReset.defaultProps = {
  zoomInTitle: "Zoom in",
  zoomOutTitle: "Zoom out",
  zoomResetTitle: "Reset zoom",
};

export default ZoomControlWithReset;
